export default __webpack_public_path__ + "static/media/clock.04d7b20b.svg";